module.exports = __webpack_public_path__ + "static/media/play_football_new.fc409039.gif";